import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import stl from "./Footer.module.css";
import useHelpers from "@hooks/useHelpers";
import { useLang } from "@/common/Contexts/LanguageContext";
import { CARS_PRICES_BASE_PATH } from "@/pages/car-prices/helpers/carsPricesHelpers";
function Footer(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      borderTop: props.hideFooterWithoutAuthMsg ? "none" : undefined
    },
    className: [stl.footer, props.hideFooterWithoutAuthMsg ? stl.hideFooterWithoutAuthMsg : undefined].join(" ")
  }, !props.hideFooterWithoutAuthMsg && /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-ftrLogo",
    style: {
      fontSize: "90px",
      display: "block",
      marginTop: "-50px",
      marginBottom: "-22px"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.dataFooterContent
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: createUrl("/"),
    className: "interActiveGray"
  }, t("الرئيسية", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/about-us")
  }, t("من نحن", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/contact-us")
  }, t("اتصل بنا", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://syarah.com/carsguide/".concat(lang === 'en' ? 'en/' : ''),
    className: "interActiveGray"
  }, t("دليل سيارة", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: createUrl(CARS_PRICES_BASE_PATH),
    className: "interActiveGray"
  }, t("أسعار السيارات", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/network"),
    rel: "noopener noreferrer"
  }, t("برنامج سيارة للتسويق بالعمولة", {
    ns: "web_footer"
  }), " ")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/trend"),
    rel: "noopener noreferrer"
  }, t("سيارة ترند", {
    ns: "web_footer"
  })))), /*#__PURE__*/React.createElement("p", {
    className: "interActiveGray"
  }, t("شركة سعوديه بسجل تجاري 1010538980 مصدره الرياض", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/terms-landing"),
    rel: "noopener noreferrer"
  }, t("الأحكام والشروط", {
    ns: "web_footer"
  }), " "), " ", "|", /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/privacy-policy"),
    rel: "noopener noreferrer"
  }, t("سياسة الخصوصية", {
    ns: "web_footer"
  }), " "), " ", "|", /*#__PURE__*/React.createElement("a", {
    className: "interActiveGray",
    href: createUrl("/return-policy"),
    rel: "noopener noreferrer"
  }, tShort("return_policy")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", {
    className: "greenGrd"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-greenArmor",
    style: {
      fontSize: "17px"
    }
  }), /*#__PURE__*/React.createElement("span", null, t("طرق دفع إلكترونية آمنة", {
    ns: "web_footer"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: stl.payment
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Mada",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path7"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path8"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path9"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Visadark",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-mc",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-apple_pay",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Sadad",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-BankTransfer",
    style: {
      fontSize: "44px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  })))), /*#__PURE__*/React.createElement("p", {
    className: "interActiveGray"
  }, t("جميع الحقوق محفوظة لشركة موقع سيارة المحدودة © ", {
    ns: "web_footer"
  }), new Date().getFullYear()))))), props.authenticationMsg && /*#__PURE__*/React.createElement("div", {
    className: stl.authenticationMsg
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, "container"].join(" ")
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-greenArmor",
    style: {
      fontSize: "17px"
    }
  }), t("شركة موقع سيارة للتجارة شركة موثقة لدى وزارة التجارة والاستثمار وبدعم من شركة علم, بسجل تجاري رقم 1010538980", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.footerWithVat
  }, /*#__PURE__*/React.createElement("a", {
    className: stl.vatLink,
    href: CDN_LINK + "/assets/bundles/GAZT_VAT_Certificate.pdf",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: "30px",
    height: "38px",
    src: CDN_LINK + "/assets/images/Vat.svg",
    alt: "vat icon"
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/saudi_elm.svg",
    alt: "saudi_elm icon",
    width: "262px",
    height: "44px"
  })))));
}
export default Footer;